import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { WarehouseActionTypes, WarehouseActions } from "../../../actionTypes/master/warehouseActionTypes";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  createWarehouseApi,
  deleteWarehouseApi,
  editWarehouseDataByIdApi,
  getWarehouseDataByIdApi,
  getWarehouseListApi,
} from "../../requests/master/warehouseRequests";
import {
  getWarehouseList,
  setWarehouseDataById,
  setWarehouseList,
  setWarehouseListPageCount,
} from "../../../actions/master/warehouseActions";


function* createWarehouseHandler(action: WarehouseActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createWarehouseApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getWarehouseListHandler(action: WarehouseActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getWarehouseListApi, action.payload);

    if (data.status) {
      yield put(setWarehouseList(data?.data?.rows));
      yield put(setWarehouseListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getWarehouseDataByIdHandler(action: WarehouseActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getWarehouseDataByIdApi, action.payload);
    if (data.status) {
      yield put(setWarehouseDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editWarehouseDataByIdHandler(action: WarehouseActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editWarehouseDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getWarehouseList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* deleteWarehouseHandler(action: WarehouseActionTypes) {
  try {
    yield startLoader("transparent");

    const { data } = yield call(deleteWarehouseApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });

      yield put(getWarehouseList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// warehouse sagas
export default function* warehouseSaga() {
  yield takeLatest(WarehouseActions.CREATE_WAREHOUSE, createWarehouseHandler);
  yield takeLatest(WarehouseActions.GET_WAREHOUSE_LIST, getWarehouseListHandler);
  yield takeLatest(WarehouseActions.GET_WAREHOUSE_DATA_BY_ID, getWarehouseDataByIdHandler);
  yield takeLatest(WarehouseActions.EDIT_WAREHOUSE_DATA_BY_ID, editWarehouseDataByIdHandler);
  yield takeLatest(WarehouseActions.DELETE_WAREHOUSE, deleteWarehouseHandler);
}
